import {AppointmentTypeApiDto} from "../../../api/model/rest";

export default class JobAppointmentType {

	constructor(public readonly id: string,
		public readonly name: string) {}

	static fromJson(json: AppointmentTypeApiDto): JobAppointmentType {
		return new JobAppointmentType(json.id, json.name);
	}

	getDisplayName(): string {
		return this.name
	}
}